import { ICampaignManagement } from '../dashboard/components/dto/ICampaignManagement';
import { requests } from '../../../../utils';
import {
    BRAND_DASHBOARD_CONTRACTS,
    BRAND_DASHBOARD_LINKED_CAMP,
    BRAND_DASHBOARD_MANAGEMENT,
} from '../../../../utils/endpoints';
import { BaseModel } from '../../../../model/shared/BaseModel';
import { ILinkedCampaigns } from '../../../../model/campaign/Campaign';
import { IContract } from '../../../../model/shared/IContract';
import { IDashContracts } from './dto/IDashContracts';

export const LongTermService = {
    getManagementData: (id: string): Promise<ICampaignManagement> =>
        requests.get(`${BRAND_DASHBOARD_MANAGEMENT}/${id}`),
    getLinkedCampaigns: (id: string, filterParams: any): Promise<BaseModel<ILinkedCampaigns[]>> =>
        requests.get(`${BRAND_DASHBOARD_LINKED_CAMP}/${id}`, filterParams),
    getContracts: (id: string, filterParams: any): Promise<IDashContracts<IContract[]>> =>
        requests.get(`${BRAND_DASHBOARD_CONTRACTS}/${id}`, filterParams),
};
